var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"the-footer d-flex align-center px-6 white--text justify-space-between",style:(_vm.footerStyle())},[_c('span',[_vm._v(_vm._s(_vm.Phone))]),_c('img',{attrs:{"src":_vm.logo,"height":"50"}}),_c('a',{staticClass:"white--text",attrs:{"href":`mailto: ${_vm.Email}`}},[_vm._v(_vm._s(_vm.Email))])])
}
var staticRenderFns = []

export { render, staticRenderFns }